export const ROLE_ORGANIZATION_ADMIN = "OrganizationAdmin";
export const ROLE_ORGANIZATION_PHYSICIAN = "Provider";
export const ROLE_ORGANIZATION_DEPARTMENT = "OrganizationDepartment";
export const ROLE_ORGANIZATION_SUBADMIN = "DepartmentAdmin";
export const ROLE_PROVIDER = "IndividualPhysician";
